import { RollupType } from 'pages/raas/helpers/labels';
import { Panel } from 'shared/types/protoc-gen/raas-metrics';

export const isOpstack = (rollupType: RollupType) =>
  rollupType === RollupType.OPSTACK || rollupType === RollupType.VERSE;

export const isOrbit = (rollupType: RollupType) => rollupType === RollupType.ORBIT;

export const getInstancesParam = (rollupType?: RollupType) => {
  switch (rollupType) {
    case RollupType.OPSTACK:
      return 'opstackId';
    case RollupType.ORBIT:
      return 'orbitId';
    default:
      return 'rollupId';
  }
};

export const getRpcCountMetricPanel = (rollupType?: RollupType) => {
  switch (rollupType) {
    case RollupType.OPSTACK:
      return Panel.PANEL_OPSTACK_DAILY_RPC_COUNT;
    case RollupType.ORBIT:
      return Panel.PANEL_ORBIT_DAILY_RPC_COUNT;
    default:
      return Panel.UNRECOGNIZED;
  }
};

export const getRpsMetricPanel = (rollupType?: RollupType) => {
  switch (rollupType) {
    case RollupType.OPSTACK:
      return Panel.PANEL_OPSTACK_RPS;
    case RollupType.ORBIT:
      return Panel.PANEL_ORBIT_RPS;
    default:
      return Panel.UNRECOGNIZED;
  }
};
